import _ from 'lodash';
import EventBus from '@/app/eventBus';
import { types } from '@/app/filters/filters';
import { ItemStatus } from '@/app/utils/constants/ItemStatus';
import { ToolkitApi } from '@/app/services/api/toolkit';
import fetchBusinessRule from '@/app/utils/toolkit/businessRules';
import { getLocalType } from '@/app/utils/toolkit/defaultItems';

export const defaultItem = {
  dirty: false,
  uuid: undefined,
  type: undefined,
  status: ItemStatus.STARTED,
  accountID: undefined,
  cognitoID: undefined,
  relation: undefined,
  data: undefined,
};

const mutations = {
  CLEAR_DIRTY(state) {
    state.item.dirty = false;
  },
  RESET_ITEM(state) {
    state.item = _.cloneDeep(defaultItem);
  },
  SET_ITEM_TYPE(state, type) {
    state.item.type = type;
  },
  SET_ITEM_KEY(state, { key, value }) {
    state.item.dirty = true;
    state.item[key] = value;
  },
};

const actions = {
  updateItemType({ commit }, type) {
    commit('SET_ITEM_TYPE', type);
  },
  clearItem: {
    root: true,
    handler: function clearItem({ commit }) {
      commit('RESET_ITEM');
    },
  },
  async loadItem({ commit, dispatch }, loadItem) {
    await dispatch('clearItem', null, { root: true });
    await dispatch('updateItemKey', loadItem);
    commit('CLEAR_DIRTY');
  },
  saveItem({ commit, state, rootGetters }, complete = false) {
    if (state.item.dirty || complete) {
      return ToolkitApi.saveItem({
        uuid: state.item.uuid,
        type: state.item.type,
        accountID: state.item.accountID,
        relation: state.item.relation,
        cognitoID: state.item.cognitoID,
        status: complete ? ItemStatus.COMPLETE : state.item.status,
        fundName: rootGetters['fund/getFund'].details.name,
        fund: {
          details: rootGetters['fund/getFund'].details,
          members: rootGetters['fund/getFund'].members,
          trustee: rootGetters['fund/getFund'].trustee,
        },
        data: state.item.data,
      })
        .then((res) => {
          commit('CLEAR_DIRTY');
          // TODO: Refactor EventBus to a notification store module - Remove EventBus
          const itemType = state.item.type === 'PENSION_PAYMENT_INSTRUCTION' ? types('BENEFIT_PAYMENT_INSTRUCTION') : types(getLocalType(state.item.type));
          EventBus.$emit('addNotification', {
            title: `${itemType} Saved!`,
            icon: 'tick',
            message: `${itemType} for ${
              rootGetters['fund/getFund'].details.name
            }`,
          });
          return res;
        })
        .catch((err) => {
          // TODO: Refactor EventBus to a notification store module - Remove EventBus
          EventBus.$emit('addNotification', {
            title: `${types(getLocalType(state.item.type))} Save Failed!`,
            icon: 'cross',
            message: `${types(getLocalType(state.item.type))} for ${
              rootGetters['fund/getFund'].details.name
            } failed to save: ${err}`,
          });
          throw new Error({
            errCode: 'TOOLKIT_ITEM_SAVE_ERR',
            errMessage: err,
          });
        });
    }
    return Promise.reject(
      new Error({
        errCode: 'TOOLKIT_ITEM_NO_CHANGE',
        errMessage: 'Item has not changed!',
      }),
    );
  },
  async updateItemKey({ commit, dispatch, state }, obj) {
    const businessRule = fetchBusinessRule({
      type: state.item.type,
      rule: obj.rule,
    });

    let appliedRulesObj;
    if (typeof businessRule === 'function') {
      appliedRulesObj = {
        data: businessRule(obj.data),
      };
    } else {
      appliedRulesObj = obj;
    }

    appliedRulesObj = await dispatch(
      'updateState',
      {
        state: state.item,
        newState: appliedRulesObj,
      },
      { root: true },
    );

    Object.keys(appliedRulesObj).forEach((key) => {
      commit('SET_ITEM_KEY', { key, value: appliedRulesObj[key] });
    });
  },
  duplicateItem({ commit, state, rootGetters }) {
    return ToolkitApi.saveItem({
      uuid: undefined,
      type: state.item.type,
      accountID: state.item.accountID,
      relation: state.item.relation,
      cognitoID: state.item.cognitoID,
      status: ItemStatus.IN_PROGRESS,
      fundName: rootGetters['fund/getFund'].details.name,
      fund: {
        details: rootGetters['fund/getFund'].details,
        members: rootGetters['fund/getFund'].members,
        trustee: rootGetters['fund/getFund'].trustee,
      },
      data: state.item.data,
    })
      .then((res) => {
        commit('CLEAR_DIRTY');
        // TODO: Refactor EventBus to a notification store module - Remove EventBus
        EventBus.$emit('addNotification', {
          title: `${types(getLocalType(state.item.type))} Duplicated!`,
          icon: 'tick',
          message: `${types(getLocalType(state.item.type))} for ${
            rootGetters['fund/getFund'].details.name
          }`,
        });
        return res;
      })
      .catch((err) => {
        // TODO: Refactor EventBus to a notification store module - Remove EventBus
        EventBus.$emit('addNotification', {
          title: `${types(getLocalType(state.item.type))} Duplication Failed!`,
          icon: 'cross',
          message: `${types(getLocalType(state.item.type))} for ${
            rootGetters['fund/getFund'].details.name
          } failed to save: ${err}`,
        });
        throw new Error({
          errCode: 'TOOLKIT_ITEM_SAVE_ERR',
          errMessage: err,
        });
      });
  },
};

const getters = {
  isItemDirty(state) {
    return state.item.dirty;
  },
  getItem(state) {
    return state.item;
  },
  getItemData(state) {
    return state.item.data;
  },
  getItemType(state) {
    return state.item.type;
  },
};

const state = {
  item: _.cloneDeep(defaultItem),
};

const toolkit = {
  namespaced: true,
  mutations,
  actions,
  getters,
  state,
};

export default toolkit;
